/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fulfillment_Instant_DownloadInputs */

const en_fulfillment_instant_download = /** @type {(inputs: Fulfillment_Instant_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instant Digital Download`)
};

const id_fulfillment_instant_download = /** @type {(inputs: Fulfillment_Instant_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unduhan Digital Instan`)
};

/** @type {(inputs: Fulfillment_Instant_DownloadInputs) => LocalizedString} */
const es_fulfillment_instant_download = en_fulfillment_instant_download;

/** @type {(inputs: Fulfillment_Instant_DownloadInputs) => LocalizedString} */
const fr_fulfillment_instant_download = en_fulfillment_instant_download;

/** @type {(inputs: Fulfillment_Instant_DownloadInputs) => LocalizedString} */
const de_fulfillment_instant_download = en_fulfillment_instant_download;

/** @type {(inputs: Fulfillment_Instant_DownloadInputs) => LocalizedString} */
const ja_fulfillment_instant_download = en_fulfillment_instant_download;

/** @type {(inputs: Fulfillment_Instant_DownloadInputs) => LocalizedString} */
const zh_fulfillment_instant_download = en_fulfillment_instant_download;

/** @type {(inputs: Fulfillment_Instant_DownloadInputs) => LocalizedString} */
const ar_fulfillment_instant_download = en_fulfillment_instant_download;

/** @type {(inputs: Fulfillment_Instant_DownloadInputs) => LocalizedString} */
const it_fulfillment_instant_download = en_fulfillment_instant_download;

/** @type {(inputs: Fulfillment_Instant_DownloadInputs) => LocalizedString} */
const ru_fulfillment_instant_download = en_fulfillment_instant_download;

/** @type {(inputs: Fulfillment_Instant_DownloadInputs) => LocalizedString} */
const pt_fulfillment_instant_download = en_fulfillment_instant_download;

/** @type {(inputs: Fulfillment_Instant_DownloadInputs) => LocalizedString} */
const ko_fulfillment_instant_download = en_fulfillment_instant_download;

/**
* | output |
* | --- |
* | "Instant Digital Download" |
*
* @param {Fulfillment_Instant_DownloadInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const fulfillment_instant_download = /** @type {((inputs?: Fulfillment_Instant_DownloadInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Instant_DownloadInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fulfillment_instant_download(inputs)
	if (locale === "es") return es_fulfillment_instant_download(inputs)
	if (locale === "fr") return fr_fulfillment_instant_download(inputs)
	if (locale === "de") return de_fulfillment_instant_download(inputs)
	if (locale === "ja") return ja_fulfillment_instant_download(inputs)
	if (locale === "zh") return zh_fulfillment_instant_download(inputs)
	if (locale === "ar") return ar_fulfillment_instant_download(inputs)
	if (locale === "id") return id_fulfillment_instant_download(inputs)
	if (locale === "it") return it_fulfillment_instant_download(inputs)
	if (locale === "ru") return ru_fulfillment_instant_download(inputs)
	if (locale === "pt") return pt_fulfillment_instant_download(inputs)
	return ko_fulfillment_instant_download(inputs)
});